import React from 'react';
import { Pie } from 'react-chartjs-2';
import Announcement from './Announcement';
import 'chartjs-plugin-datalabels';

function CostPieChart({
  reports, title, strIncome, strCost
}) {
  const options = {
    plugins: {
       datalabels: {
            formatter: function(value, context) {
                var sum = reports[0].cost + reports[1].cost + reports[2].cost + reports[3].cost;
                return context.chart.data.labels[context.dataIndex] + '-' + (value/sum*100).toFixed(0) + '%';
            },
            display: function(context) {
              return context.dataset.data[context.dataIndex] !== 0; // or >= 1 or ...
           },
            color: 'black',
            font:{
              size: 15
            }
        },
    },
    title: {
     display: true,
     text: title,
     fontSize: 25,
     fontColor: 'black'
    },
    maintainAspectRatio: false,
  };
  const data = {
    datasets: [{
        data: reports.length ? reports.map(yearReport => yearReport.cost) : [],
        backgroundColor: reports.length ? [ 'rgba(255, 99, 132, 0.6)',
                'rgba(54, 162, 235, 0.6)',
                'rgba(255, 206, 86, 0.6)',
                'rgba(75, 192, 192, 0.6)'] : [],

    }],

    // These labels appear in the legend and in the tooltips when hovering different arcs
    labels:reports.length ? reports.map(yearReport => yearReport.department) : []
  };

  if (reports && reports.length && reports[0] === 0) {
    return (
      <div className="loading__overlay">
        <div className="loading__content">
          <div className="spinner" />
        </div>
      </div>
    );
  }

  if (reports && reports.length === 0) {
    return <Announcement title={title} content="目前還沒有資料" />;
  }

  return (
      <div className="row" style={{ overflowX: 'auto', marginBottom: '20px', padding: '2px'}}>
      <div className="col-9 col-pad-12" style={{ position: 'relative',height:'400px', width: '100%'}}>
          <Pie data={data} options={options} />
      </div>
      <div className="col-3 col-pad-12">
          <table className="u-table u-table-border u-table-striped">
            <thead>
              <tr>
                <th>部門</th>
                <th>成本</th>
              </tr>
            </thead>
            <tbody>
              {
                reports.map((item, index) => (
                  <tr key={item+index}>
                    <td key={item+index+'department'}>{item.department}</td>
                    <td key={item+index+'cost'}>{item.cost}</td>
                  </tr>
                  )
                )
              }
            </tbody>
          </table>
      </div>
    </div>

  );
}

export default CostPieChart;
